<template>
  <div>
    <v-dialog v-model="confirmDialog" persistent max-width="400">
      <v-card>
        <v-card-title>{{ title || $t('validate.you_want_to_delete') }}</v-card-title>
        <v-card-text v-if="description">
          {{ description }}
          <slot name="content"></slot>     
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn
            :color="cancelColor || 'grey lighten-3'"
            elevation="0"
            :disabled="disabled || !confirmDialog"
            :loading="loading"
            @click="confirmDialog = false"
          >
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn
            :color="confirmColor || 'error'"
            elevation="0"
            :loading="loading"
            :disabled="disabled || !confirmDialog"
            @click="$emit('onOk')"
          >
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PageName",
  computed: {
    confirmDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  created() {},
  data() {
    return {};
  },
  props: {
    value: Boolean,
    cancelColor: String,
    confirmColor: String,
    title: String,
    disabled: Boolean,
    loading: { type: Boolean, default: false },
    description: String
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
